import { WifiOff, Wifi } from "lucide-react";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";

// Slim, non-blocking banner shown when the device is offline (or just reconnected).
// Works with the service worker, which keeps the last-loaded public content readable.
export function OfflineBanner() {
  const { online, justReconnected } = useOnlineStatus();

  if (online && !justReconnected) return null;

  if (online && justReconnected) {
    return (
      <div
        data-testid="online-banner"
        className="fixed top-0 inset-x-0 z-[9999] flex items-center justify-center gap-2 px-4 py-1.5 text-sm font-medium text-white bg-pula-green shadow-md"
        role="status"
      >
        <Wifi className="w-4 h-4" />
        Back online — refreshing your feed.
      </div>
    );
  }

  return (
    <div
      data-testid="offline-banner"
      className="fixed top-0 inset-x-0 z-[9999] flex items-center justify-center gap-2 px-4 py-1.5 text-sm font-medium text-white bg-pula-ink shadow-md"
      role="status"
    >
      <WifiOff className="w-4 h-4" />
      You're offline — showing saved content. We'll refresh when you're back.
    </div>
  );
}
